import React from 'react';

import { Text } from '../../../storyblocks-design-system/components/atoms/Text/Text';
import LinkWrapper from '../../elements/LinkWrapper/LinkWrapper';
import ProgressiveImage from '../../elements/ProgressiveImage/ProgressiveImage';
import type { Testimonial } from './Testimonial.type';
import { TestimonialAuthor } from './TestimonialAuthor';

export const TestimonialCard = ({
  name,
  title,
  quote,
  image,
  imageAlt,
  lazyLoadImage,
  link,
}: Testimonial) => (
  <LinkWrapper link={link} className="flex flex-col h-full">
    <article
      className="bg-blue-50 rounded-lg p-6 md:p-8 pt-26 md:pt-26 mt-14 relative h-full"
      aria-labelledby={`testimonial-author-${name
        .replace(/\s+/g, '-')
        .toLowerCase()}`}
    >
      <div
        className="w-28 h-28 rounded-lg overflow-hidden flex-shrink-0 absolute -top-14 left-8"
        aria-hidden="true"
      >
        <ProgressiveImage
          className="w-full h-full object-cover"
          src={image}
          alt={imageAlt || `Photo of ${name}`}
          shouldLazyLoad={lazyLoadImage}
          width="100%"
          height="100%"
        />
      </div>
      <div className="space-y-4" role="group" aria-label="Customer testimonial">
        <Text
          asChild
          fontFamily="polysans"
          fontSize="lg"
          fontWeight="regular"
          className="text-gray-900"
        >
          <blockquote
            dangerouslySetInnerHTML={{ __html: quote }}
            cite={name}
            aria-label="Customer testimonial quote"
          />
        </Text>
        <TestimonialAuthor name={name} title={title} />
      </div>
    </article>
  </LinkWrapper>
);
